import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ModelInfo(props) {
  return (
    <>
      <Modal size='lg' centered show={props.show} onHide={props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Detalis</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.lng == "en" ?
            <div className='regular-font-set'>
              <p className=''>The calculation programme is used to compare the costs of using a bladder tank with those of a FireDos proportioning system over time. You receive a cost overview in just a few steps.</p>

              <p className=''>
                Enter the system parameters for the bladder tank and the proportioning system. The following results will be displayed in comparison:
              </p>
              <p className='m-0'>-	Costs for testing the proportioning rate</p>
              <p className='m-0'>-	Total operating costs</p>
              <p className='m-0'>-	Development of the total costs over time</p>
              <p className=''>-	Cost savings through FireDos </p>

              <p className=''> Check the results in the results area using the diagram and the results fields.</p>
              <p className='m-0'>-	Make adjustments if necessary.</p>
              <p className='m-0'>-	Export the result as a PDF.</p>
              <p className=''>-	Contact your sales partner or FireDos.</p>
              <p className='label-set-size'>
                Explanation of terms:
              </p>
              <p>The proportioning rate is the ratio in which foam concentrate is added to the water. A proportioning rate of 1 % means that one litre of premix is made up of 10 ml foam concentrate and 990 ml water.</p>
              <p>Premix is created when foam concentrate is added to the extinguishing water. If premix comes into contact with air, extinguishing foam is produced. </p>
              <p className='label-set-size'> General notes:</p>
              <p>The language switchover is automatically based on the selected home page language. If your language is not available, English is automatically selected.</p>
              <p>On mobile devices, the calculator app adapts automatically to enable simple operation.</p>
              <p className='label-set-size'>Operating instructions: </p>
              <p>The parameters can be inserted using the number buttons and counted up or down in increments of one using the arrow elements (costs for premix disposal in increments of 0.5).</p>
              <p>In the results area, all important parameters are shown in numerical form, as well as the total costs and the cost savings through FireDos in the form of a graph.</p>
              <p>The settings and the result can be saved as a PDF using the ‘Export PDF’ button.</p>
            </div>
            :

            <div className='regular-font-set'>
              <p className=''>Das Berechnungsprogramm dient dazu, die Kosten für den Einsatz eines Blasentanks mit jenen eines FireDos-Zumischsystems im zeitlichen Verlauf zu vergleichen. In nur wenigen Schritten erhalten Sie eine Kostenübersicht.</p>

              <p className=''>
                Geben Sie die Systemparameter für den Blasentank und das Zumischsystem ein. Ihnen werden die folgenden Ergebnisse im Vergleich angezeigt:
              </p>
              <p className='m-0'>- Kosten für das Testen der Zumischrate</p>
              <p className='m-0'>- Betriebskosten gesamt</p>
              <p className='m-0'>- Entwicklung der Gesamtkosten im zeitlichen Verlauf</p>
              <p className=''>-Kostenersparnis durch FireDos </p>

              <p className=''>Überprüfen Sie die Ergebnisse im Ergebnisbereich anhand des Diagramms und der Ergebnisfelder.</p>
              <p className='m-0'>- Nehmen Sie bei Bedarf Anpassungen vor.</p>
              <p className='m-0'>- Exportieren Sie das Ergebnis als PDF.</p>
              <p className=''>- Kontaktieren Sie Ihren Vertriebspartner oder FireDos.</p>
              <p className='label-set-size'>
                Begriffserklärungen:
              </p>
              <p>Unter Zumischrate versteht man die Relation, in welcher Schaummittel dem Wasser zugemischt wird. Eine Zumischrate von 1 % bedeutet, dass sich ein Liter Premix aus 10 ml Schaummittel und 990 ml Wasser zusammensetzt.</p>
              <p>Premix entsteht, wenn Schaummittel dem Löschwasser zugemischt wird. Kommt Premix mit Luft in Verbindung, so entsteht Löschschaum.  </p>
              <p className='label-set-size'> Allgemeine Hinweise:</p>
              <p>Die Sprachumschaltung richtet sich automatisch nach der gewählten Homepagesprache. Ist Ihre Sprache nicht verfügbar, so wird automatisch Englisch ausgewählt.</p>
              <p>Auf mobilen Endgeräten passt sich der Kalkulator automatisch an, um eine einfache Bedienung zu ermöglichen.</p>
              <p className='label-set-size'>Bedienhinweise:  </p>
              <p>Die Parameter können über die Zahlentasten eingefügt und mithilfe der Pfeilelemente in Einer-Schritten (Kosten für die Premix-Entsorgung in 0,5er Schritten) hoch- oder runtergezählt werden.</p>
              {/* <p>Auf was sollte man achten? Welche Felder müssen unbedingt ausgefüllt werden? (wir haben nur optionale Felder, keine Pflichtfelder, es gibt kaum Abhängigkeiten). Welche Werte müssen unbedingt korrekt sein?</p> */}
              <p>Im Ergebnisbereich werden alle wichtigen Kennwerte in numerischer Form gezeigt, sowie die Gesamtkosten als auch die Kostenersparnis durch FireDos in Form eines Graphen dargestellt.</p>
              <p>Die Einstellungen und das Ergebnis lassen sich mit dem Knopf „PDF exportieren“ als PDF abspeichern.</p>
            </div>

          }

        </Modal.Body>
        <Modal.Footer>
          <Button className='Explanation' onClick={props.handleClose}>
               Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModelInfo;